module.exports = __webpack_public_path__ + "static/img/20211211_6.9cc5e61.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/2021/20211211_6.png
// module id = X1BT
// module chunks = 0